module.exports = __webpack_public_path__ + "img/cmi_logo.bb317bad.png";